export enum OperationType {
  PIX = "PIX",
  TRANSFER = "TRANSFER",
}

export enum PixType {
  CPF = "CPF",
  CNPJ = "CNPJ",
  PHONE = "PHONE",
  EMAIL = "EMAIL",
  RANDOM = "RANDOM",
}
